<template>
	<van-tabbar v-model="activeIndex" :fixed="true"  safe-area-inset-bottom active-color="#8B6E35">
		<van-tabbar-item to="/">
			<span class="iconfont icon-home"></span>
			<div class="item-label">{{$t('主页')}}</div>
		</van-tabbar-item>
		<van-tabbar-item to="/category">
			<span class="iconfont icon-lims"></span>
			<div class="item-label">{{$t('商品')}}</div>
		</van-tabbar-item>
		<van-tabbar-item to="/agency">
			<span class="iconfont icon-team"></span>
			<div class="item-label">{{$t('团队')}}</div>
		</van-tabbar-item>
		<van-tabbar-item to="/activity-center">
			<span class="iconfont icon-activity"></span>
			<div class="item-label">{{$t('活动')}}</div>
		</van-tabbar-item>
		<van-tabbar-item to="/ucenter">
			<span class="iconfont icon-user"></span>
			<div class="item-label">{{$t('我的')}}</div>
		</van-tabbar-item>
	</van-tabbar>
</template>

<script>
	export default {
		name: 'Foot',
		props: {
			active: {
				type: Number,
				default: 0
			}
		},
		computed: {
			activeIndex: {
				get: function () {
					return this.active;
				},
				set: function () {
				}
			}
		},
		data() {
			return {};
		},
		methods: {
		},
		mounted() {},
	}
</script>
<style>
	.van-tabbar{
		text-align: center;
		box-shadow: 0px -1px 11px 0px rgba(113, 53, 0, 0.09);
	}
	.van-tabbar .iconfont{
		font-size: 22px;
	}
	.van-tabbar::after{
		display: none;
	}
	.van-tabbar-item{
		color: #909090;
	}
	.van-tabbar-item--active{
		color: #222222;
	}
	.van-tabbar,
	.van-tabbar__placeholder{
		height: calc(60px + constant(safe-area-inset-bottom))!important;
		height: calc(60px + env(safe-area-inset-bottom))!important;
	}
	.item-label{
		margin-top: 5px;
		font-size: 12px;
	}


</style>